import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

interface MathOperation {
	type: string;
	sign: string;
	selected: boolean;
}

export default class ScriptsFormPopupOptionsMathComponent extends PopupInnerContextComponent<PopupData.Script.OptionsMath> {
	get model() {
		return this.popupData.model;
	}

	get isAddingNew() {
		return !this.model;
	}

	get operations() {
		const type = this.model?.type;

		const operations: MathOperation[] = [
			{ type: 'addition', sign: '+', selected: type === '+' },
			{ type: 'subtraction', sign: '-', selected: type === '-' },
			{ type: 'division', sign: '/', selected: type === '/' },
			{ type: 'multiplication', sign: '*', selected: type === '*' },
		];
		if (!this.isAddingNew) {
			operations.push({
				type: 'brackets',
				sign: '()',
				selected: !!this.model?.isBracketSelected,
			});
		}
		return operations;
	}

	@action
	changeOperation(operation: MathOperation) {
		if (operation.type === 'brackets') {
			this.changeBrackets(!operation.selected);
			this.close();
		} else if (!operation.selected) {
			if (this.isAddingNew) {
				if (this.popupData.addNewOperator) {
					this.popupData.addNewOperator(operation.sign);
				}
			} else if (this.model) {
				this.model.type = operation.sign;
			}
			this.close();
		}
	}

	@action
	changeBrackets(isSelect: boolean) {
		this.popupData.changeBrackets(this.model, isSelect);
	}
	<template>
		<div class="content">
			{{#each this.operations as |operation|}}
				<a
					role="button"
					{{on "click" (fn this.changeOperation operation)}}
					class="math-{{operation.type}} {{if operation.selected 'selected'}}"
				></a>
			{{/each}}
		</div>
	</template>
}
